import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Breadcrumb, Button, ButtonToolbar} from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import genericRadioFilter from '../Common/genericRadioFilter';
import Spinner from '../Widgets/spinner';
import ContentWrapper from '../Layout/ContentWrapper';
import { DateFormatter, formatDate } from '../Common/dateFormat';
import dateFilterRadios from '../Common/dateFilterRadios';
import { Field } from 'redux-form';
import { Selection } from '../Common/selection';
import { ROOT_URL, companyCodeTitle, isOLG } from '../../actions/root_url';
import { toFromDates } from '../Common/cleanDates';

const tableHeight = (window.innerHeight < 930) ? 700 : 700;

class ActionLog extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      logs: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      FromDate: undefined,
      ToDate: undefined,
      action: '',
      field: '',
      days: '7',
    };
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    const FromDate = this.state.FromDate ? formatDate(this.state.FromDate) : '1900-01-01';
    const ToDate = this.state.ToDate ? formatDate(this.state.ToDate) : '3000-01-01';
    let days = this.state.days;
    const field = this.state.field;
    const action =  this.state.action;
    if (days == null) {
      days = 90; 
    }
    this.props.fetchActionLogByFilter(action, field, days, FromDate, ToDate);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.actionLog && this.props.actionLog !== nextProps.actionLog) {
      const { logs } = this.state;
      this.setState({ logs: { ...logs, rows: nextProps.actionLog } });
    }
    if (nextProps.field && this.props.field != nextProps.field) {
      this.setState({
        field: nextProps.field.value
      }, () => {
        const FromDate = this.state.FromDate ? formatDate(this.state.FromDate) : '1900-01-01';
        const ToDate = this.state.ToDate ? formatDate(this.state.ToDate) : '3000-01-01';
        let days = this.state.days;
        
        let field = nextProps.field;
        if (nextProps.field) {
          field = nextProps.field.value;
        }
        const action =  this.state.action;
        if (days == null) {
          days = 90; 
        }
        this.props.fetchActionLogByFilter(action, field, days, FromDate, ToDate);
      });
    }

    if (this.props.field && nextProps.field == null) {
      this.setState({
        field: nextProps.field
      }, () => {
        const FromDate = this.state.FromDate ? formatDate(this.state.FromDate) : '1900-01-01';
        const ToDate = this.state.ToDate ? formatDate(this.state.ToDate) : '3000-01-01';
        let days = this.state.days;
        const field = nextProps.field;
        const action =  this.state.action;
        if (days == null) {
          days = 90; 
        }
        this.props.fetchActionLogByFilter(action, field, days, FromDate, ToDate);
      });
    }
  }

  handleFilterStatusChange = (status) => {
    const fromDate = this.state.fromDate ? formatDate(this.state.FromDate) : '1900-01-01';
    const ToDate = this.state.ToDate ? formatDate(this.state.ToDate) : '3000-01-01';
    let days = this.state.days;
    const field = this.state.field;
    if (days == null) {
      days = 90; 
    }
    this.setState({
      action: status
    }, () => {
      this.props.fetchActionLogByFilter(this.state.action, field, days, fromDate, ToDate)
    });
  }

  renderPrint() {
    const fromDate = this.state.FromDate ? formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? formatDate(this.state.ToDate) : '3000-01-01';
    let days = this.state.days;
    const field = this.state.field;
    const action = this.state.action
    const dates = toFromDates(days, fromDate, toDate);
    const url = `${ROOT_URL}v1/dashboard/audit_trail_filter/export/?Action=${action}&Field=${field}&Date__gte=${dates.fromDate}&Date__lte=${dates.toDate}&Bearer=${localStorage.getItem('token')}`;
    return (
      <Button
      bsStyle='primary'
      type='button'
      href={url}
    >
      <em className='fa fa-print' /><Translate value="print_log" />
    </Button>
    )
  }

  handleDaysStatusChange = (days) => {
    let dateRange = 90;
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    if (this.state.FromDate != null) {
      FromDate = this.state.FromDate
    }
    if (this.state.ToDate != null) {
      ToDate = this.state.ToDate;
    }
    if (days !== null) {
      dateRange = days;
    }
    if (days === -1 || days === '-1') {
      this.setState({
        days: days
      }, () => {
        this.props.fetchActionLogByFilter(this.state.action, this.state.field, days, FromDate, ToDate);
      })
    } else {
      this.setState({
        days: days,
        FromDate: null,
        ToDate: null,
      }, () => {
        this.props.fetchActionLogByFilter(this.state.action, this.state.field, days, FromDate, ToDate);
      });
    }
  }

  setToRangeSearch = (e) => {
    this.setState({ days: '-1' });
  }

  setFromDate = (e) => {
    if (e > this.state.ToDate) {
      return;
    }
    this.setState(
      { FromDate: e },
    );
  }

  setToDate = (e) => {
    if (e < this.state.FromDate) {
      return;
    }
    this.setState(
      { ToDate: e },
    );
  }

  renderFields = () => {
    const fields = this.getFields();
    return (
      <div className="control-dropdown" style={{marginBottom: 5}}>
       <span>Search:</span> <Field name="Field" component={Selection} options={fields} />
      </div>
    );
  }
  
  getFields = () => {
    return (
    [
      { value: 'ProductCost', label: 'Product Cost'}, 
      { value: 'P5Percentage', label: 'P5Percentage'},
      { value: 'LowestSalePrice', label: 'Lowest Sales Price'}, 
      { value: 'RefPrice', label: 'Ref Price'},  
      { value: 'SaleStatus', label: 'SaleStatus'}, 
      { value: 'ArrivalStatus', label: 'Arrival Status'},
      { value: 'P4Percentage', label: 'P4Percentage'}, 
      { value: 'P1Percentage', label: 'P1Percentage'},  
      { value: 'ReturnStatus', label: 'Return Status'}, 
      { value: 'P2Percentage', label: 'P2Percentage'}, 
      { value: 'P3Percentage', label: 'P3Percentage'}, 
      { value: 'IsDiscontinued', label: 'Is Discontinued'}, 
      { value: 'Add Item', label: 'Add Item'}, 
      { value: 'IsStopSale', label: 'IsStopSale'}, 
      { value: 'RemoveItem', label: 'Remove Item'}, 
      { value: 'Change Quantity', label: 'Change Quantity'}, 
      { value: 'IsStopPurchase', label: 'IsStopPurchase'}, 
      { value: 'PackageSize', label: 'Package Size'}, 
      { value: 'invoice_status', label: 'Invoice Status'}, 
      { value: 'InStockPrice', label: 'InStockPrice'},  
    ]
    );
  }

  renderTable() {
    if (this.props.actionLogIsLoading && !this.props.actionLogError) {
      return <Spinner />;
    } else if (this.props.actionLogError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.actionLogError)}
          </div>
        </ContentWrapper>
      );
    }
    const columns = [
      {
        key: 'Date',
        name: <Translate value="date" />,
        sortable: true,
        resizable: true,
        width: 110,
        formatter: DateFormatter,
      },
      {
        key: 'Name',
        name: <Translate value="name" />,
        sortable: true,
        filterable: true,
        resizable: true,
        width: 110,
      },
      {
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        sortable: true,
        filterable: true,
        resizable: true,
        width: 110,
      },
      ...isOLG ? [] : [{
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        sortable: true,
        filterable: true,
        resizable: true,
        width: 110,
      }],
      {
        key: 'Field',
        name: <Translate value="field" />,
        sortable: true,
        filterable: true,
        resizable: true,
        width: 110,
      },
      {
        key: 'From',
        name: <Translate value="old_value" />,
        sortable: true,
        filterable: true,
        resizable: true,
        width: 110,
      },
      {
        key: 'To',
        name: <Translate value="new_value" />,
        sortable: true,
        filterable: true,
        resizable: true,
        width: 110,
      },
      {
        key: 'Action',
        name: <Translate value="action" />,
        sortable: true,
        filterable: true,
        resizable: true,
        width: 150,
      },
    ];

    const getRows = () => Data.Selectors.getRows(this.state.logs);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const logs = Object.assign({}, this.state.logs, { sortColumn, sortDirection });
      this.setState({ logs });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.logs.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const logs = { ...this.state.logs, filters: newFilters };
      this.setState({ logs });
    };

    return (
      <div id="salesOrders-dataGrid1" style={{marginTop: -20}}>
        <ReactDataGrid
          rowKey="id"
          onGridSort={handleGridSort}
          toolbar={<Toolbar enableFilter />}
          onAddFilter={handleFilterChange}
          columns={columns}
          rowHeight={25}
          headerRowHeight={45}
          minHeight={500}
          rowGetter={rowGetter}
          rowsCount={getSize()}
        />
      </div>
    );
  }

  render() {
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="admin" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="action_log" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="sales-orders-list">
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={2}>
                    <h3 className="filter-title"><Translate value="order_status" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {
                        genericRadioFilter({
                          content: [
                            {
                                option: '',
                                id: 'all-radio-filter',
                                name: 'statusFilterRadios',
                                labelName: 'all',
                            },
                            {
                                option: 'Create',
                                id: 'Create-radio-filter',
                                name: 'statusFilterRadios',
                                labelName: 'Create',
                            },
                            {
                                option: 'Edit',
                                id: 'Edit-radio-filter',
                                name: 'statusFilterRadios',
                                labelName: 'Edit',
                            },
                            {
                                option: 'Void',
                                id: 'Void-radio-filter',
                                name: 'statusFilterRadios',
                                labelName: 'Void',
                            },
                          ],
                          value: this.state.action,
                          handleOnClick: this.handleFilterStatusChange,
                          type: 'buttons',
                        })
                      }
                    </div>
                  </Col>
                  <Col xs={2}>
                    <h3 className="filter-title"><Translate value="order_date" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={10}>
                    {
                      dateFilterRadios({
                        handleOnClick: this.handleDaysStatusChange,
                        setFromDate: this.setFromDate,
                        setToDate: this.setToDate,
                        setToRangeSearch: this.setToRangeSearch,
                        FromDate: this.state.FromDate,
                        ToDate: this.state.ToDate,
                        Days: this.state.days,
                      })
                    }
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
            <ButtonToolbar id="breadcrumbButtonGroup">
            {this.renderPrint()}
          </ButtonToolbar>             
        <Panel className="position-relative" style={{minHeight: 500}}>
        <Row style={{ maxWidth: '99%' }}> 
            {this.renderFields()}
        </Row>
          <Row>
            <Col sm={12}>
              <div style={{ maxWidth: '99%'}}>
                { this.renderTable() }
              </div>
            </Col>
          </Row>
          <Row style={{ maxWidth: '99%' }}>
            <span className="pull-right">
              <Translate value="msg_show_action_log_from_last_90_days" />
            </span>
          </Row>
        </Panel>
      </Grid>
    </ContentWrapper>
    );
  }
}

export default ActionLog;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/ActionLog.jsx